var map = {
	"./Octocat.png": "170a",
	"./django.png": "b850",
	"./drf.png": "4623",
	"./js.png": "4d42",
	"./js.png:Zone.Identifier": "ad16",
	"./linux.png": "644b",
	"./nginx.png": "d614",
	"./postgres.png": "279c",
	"./python.png": "90f2",
	"./vuejs.png": "7b0b0"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7e92";